import "./style.scss";
import { Typography, Box, IconButton, Dialog, DialogContent, Button } from "@mui/material"
import { useEffect, useState } from "react"
import CloseIcon from '@mui/icons-material/Close';

import Cookies from 'js-cookie';

import promoVideo from "../../static/images/promos/blacknovember.mp4"
import promoImage from "../../static/images/promos/summer2026.jpg"

const COOKIE_NAME = "spring2026_seen"

export const PromoPopup = ({ open, onClose }) => {
  return <Dialog open={open} onClose={onClose}
    PaperProps={{
      elevation: 10,
    }}
  >
    <IconButton
      aria-label="close"
      onClick={onClose}
      sx={(theme) => ({
        position: 'absolute',
        right: 8,
        top: 8,
        color: "white",
      })}
    > <CloseIcon /></IconButton>
    <img src={promoImage} />

    {/* <video autoPlay muted loop>
      <source src={promoVideo} type="video/mp4"></source>
    </video> */}

    <DialogContent sx={{ justifyContent: "center", textAlign: "center", background: "black", color: 'rgb(249,245,238)' }} >
      <Box>
        <i>Summer Sale</i> is here! <br />Claim <b>30% discount</b> with code SUMMER30 at checkout
      </Box>

      <Box sx={{ mt: 3 }}>
        <Button
          color="primary"
          variant="contained"
          sx={{
            background: "white",
            color: "black",
          }}
          onClick={() => { Cookies.set(COOKIE_NAME, 'true', { expires: 7 }); window.location.href = "/software" }}>Shop Now</Button>
      </Box>
    </DialogContent>
  </Dialog >
}

export const ReclameBanner = () => {
  return (
    <Box sx={{
      bottom: 0,
      width: "100%",
      position: 'fixed',
      alignItems: "center",
      textAlign: "center",
      padding: 2,
      background: "#f22a2a",
      zIndex: 10,
    }}>
      <Typography variant="h5"><b>Summer Sale</b> - Use code SUMMER30 at checkout for 30% off</Typography>
    </Box>
  )
}


export const PromoPopupHandler = () => {
  const [promoOpen, setPromoOpen] = useState(false);
  const [showPromoBanner, setShowPromoBanner] = useState(false);
  const [startShowPromo, setStartShowPromo] = useState(false);

  useEffect(() => {
    let cookieSet = Cookies.get(COOKIE_NAME);
    // cookieSet = false;
    if (cookieSet) {
      setPromoOpen(false);
      setShowPromoBanner(true);
    } else {
      // expires in 7 days
      setStartShowPromo(true);
    }
  }, []);

  useEffect(() => {
    if (startShowPromo)
      setTimeout(() => { setPromoOpen(true) }, 666)

  }, [startShowPromo])

  return (
    <>
      <PromoPopup open={promoOpen} onClose={() => { setPromoOpen(false); setShowPromoBanner(true); Cookies.set(COOKIE_NAME, 'true', { expires: 31 }); }} />

      {showPromoBanner && <ReclameBanner />}
    </>
  )
}


